document.addEventListener("DOMContentLoaded", () => {
  const introSection = document.querySelector("#single-testimonial");
  const stickyButton = document.getElementById("sticky-button");


  if (introSection && stickyButton) {

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.boundingClientRect.top <= 0) {
            // section has reached the top
            stickyButton.classList.add("active");
          } else {
            stickyButton.classList.remove("active");
          }
        });
      },
      {

        rootMargin: "-0% 0% -100% 0%",
        threshold: 0,      // fire as soon as it crosses the threshold
      }
    );

    observer.observe(introSection);
  }
});
